import React from 'react';

import { AppWrapper } from './lib/PST.Web.Common/src/AppWrapper';
import { DatePickerUtilsProvider } from './lib/PST.Web.Common/src/components/DatePickerUtilsProvider';
import { ErrorBoundary } from './lib/PST.Web.Common/src/components/ErrorBoundary/ErrorBoundary';
import { Router } from './router/Router';
import { ErrorPage } from './scenes/ErrorPage/ErrorPage';
import { setup } from './services/setup';
import { persistor, store } from './services/store/store';

setup(store);

const App = () => (
    <ErrorBoundary ErrorPage={ErrorPage}>
        <DatePickerUtilsProvider>
            <AppWrapper store={store} persistor={persistor} setupIntl withEssentialReload>
                <Router />
            </AppWrapper>
        </DatePickerUtilsProvider>
    </ErrorBoundary>
);

export { App };
